import { Observable, distinctUntilChanged, map, startWith } from "rxjs";
import { type AnyElement } from "@zyzgroup/core-common";
import { useScroll$, getViewport } from "./useElementEvents";
import { useIntersection$ } from "./useIntersection";

export function useVisibleSimple$(
  el: AnyElement,
  options?: { root?: HTMLElement }
): Observable<boolean> {
  return useScroll$().pipe(
    startWith(null),
    map(() => {
      const { width, height } =
        options?.root?.getBoundingClientRect() || getViewport();
      const { top, left, right, bottom } = el.getBoundingClientRect();
      return (
        ((top >= 0 && top <= height) || (bottom >= 0 && bottom <= height)) &&
        ((left >= 0 && left <= width) || (right >= 0 && right <= width))
      );
    }),
    distinctUntilChanged()
  );
}

export function useVisible$(
  el: AnyElement,
  options?: {
    threshold?: number; // 表示重叠面积占被观察者的比例，从 0 - 1 取值，1 表示完全被包含
    root?: HTMLElement; // 必须是目标元素的父级元素
  }
): Observable<boolean> {
  const threshold =
    typeof options?.threshold == "number" ? options.threshold : 0.5;
  return useIntersection$(el, {
    threshold: threshold,
    root: options?.root
  }).pipe(
    map((entry: IntersectionObserverEntry) => {
      // browsers can report isIntersecting as true, but intersectionRatio as 0, when something very slowly enters the viewport
      return entry.isIntersecting && entry.intersectionRatio >= threshold;
    }),
    distinctUntilChanged()
  );
}
